export default (function (value) {
  return typeof value === 'string';
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isString.js
// module id = 1004
// module chunks = 2